
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping-guide",
      function () {
        return require("private-next-pages/shipping-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping-guide"])
      });
    }
  